module.exports = __webpack_public_path__ + "img/list_2_zh.2c8816ee.png";